import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import MainLayout from './components/Layout/MainLayout';
import Login from './pages/Login';
import { AuthProvider, useAuth } from './context/AuthContext';
import { routeConfig } from './routes';

const AppRoutes = () => {
  const { user } = useAuth();

  // If user is not logged in, only allow access to the login page
  if (!user) {
    return (
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    );
  }

  // If user is logged in, set up the main application routes
  return (
    <Routes>
      {/* 1. Explicitly redirect the root path to the dashboard */}
      <Route path="/" element={<Navigate to="/dashboard" replace />} />

      {/* 2. All other paths are rendered within MainLayout */}
      <Route path="/*" element={<MainLayout />}>
        {Object.entries(routeConfig).map(([path, config]) => (
          <Route key={path} path={path.substring(1)} element={config.component} />
        ))}
        {/* Fallback for any other authenticated route */}
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Route>
    </Routes>
  );
};

const App = () => {
  return (
    <AuthProvider>
      <Router>
        <AppRoutes />
      </Router>
    </AuthProvider>
  );
};

export default App;
